import { useQuery } from '@apollo/client'
import { USER_CHECKLISTS } from './queries'
import {
  AllChecklistsQuery,
  AllChecklistsQueryVariables,
} from './types.graphql'
import { UserNode } from 'modules/users'

export function useUserChecklists(
  user: UserNode,
  onCompleted?: (data: AllChecklistsQuery) => void,
  mandatoryOnly: boolean = false
) {
  const { loading, data } = useQuery<
    AllChecklistsQuery,
    AllChecklistsQueryVariables
  >(USER_CHECKLISTS, {
    variables: {
      user: user.id,
      mandatoryOnly: mandatoryOnly,
    },
    onCompleted: data => {
      onCompleted && onCompleted(data)
    },
    fetchPolicy: 'cache-and-network',
  })

  return {
    userChecklists: data,
    hasUnresolvedChecklists: !!data?.allChecklists.edges.some(
      edge => edge.node.active && edge.node.mandatory
    ),
    loading,
  }
}
